/**
 * @name COMPARE_PARTS_MINIMUM
 * @constant
 * @description Determines how many parts need to be selected in order to compare 
 */
export const COMPARE_PARTS_MINIMUM = 2;

/**
 * @name LEFT
 * @constant
 * @description Class name for dragging
 */
export const LEFT = 'left';

/**
 * @name OFFSET
 * @constant
 * @description Determines, in pixels, the offset from the top of the page the parameter filters
 * should be once they are sticky
 */
export const OFFSET = 30;

/**
 * @name SCROLL_SPEED
 * @constant
 * @description 
 */
export const SCROLL_SPEED = 15;

/**
 * @name RIGHT
 * @constant
 * @description Class name for dragging
 */
export const RIGHT = 'right';

/**
 * @name TARGET
 * @constant
 * @description Class name for dragging
 */
export const TARGET = 'target';